 import React, { useState, useEffect, useRef } from 'react';
 import './styles/SendMessageModal.css';
 
 const SendMessageModal = ({ isOpen, selectedUsers, onSend, onClose }) => {
   const [message, setMessage] = useState('');
   const textareaRef = useRef(null);
 
   // Focus textarea when modal opens
   useEffect(() => {
     if (isOpen && textareaRef.current) {
       setTimeout(() => textareaRef.current.focus(), 100);
     }
   }, [isOpen]);
 
   // Handle ESC key
   useEffect(() => {
     const handleEsc = (e) => {
       if (e.key === 'Escape' && isOpen) {
         handleClose();
       }
     };
     document.addEventListener('keydown', handleEsc);
     return () => document.removeEventListener('keydown', handleEsc);
   }, [isOpen]);
 
   // Prevent background scroll when modal is open
   useEffect(() => {
     if (isOpen) {
       document.body.style.overflow = 'hidden';
     } else {
       document.body.style.overflow = '';
     }
     return () => {
       document.body.style.overflow = '';
     };
   }, [isOpen]);
 
   const handleClose = () => {
     setMessage('');
     onClose();
   };
 
   const handleSend = () => {
     if (message.trim()) {
       onSend(message.trim());
       setMessage('');
     }
   };
 
   const handleOverlayClick = (e) => {
     if (e.target === e.currentTarget) {
       handleClose();
     }
   };
 
   if (!isOpen) return null;
 
   return (
     <div className="send-message-overlay" onClick={handleOverlayClick}>
       <div className="send-message-modal" role="dialog" aria-modal="true" aria-labelledby="send-message-title">
         <div className="send-message-header">
           <h3 id="send-message-title" className="send-message-title">
             Send Message
           </h3>
           <button
             className="send-message-close"
             onClick={handleClose}
             aria-label="Close modal"
           >
             <CloseIcon />
           </button>
         </div>
 
         <div className="send-message-content">
           <p className="send-message-subtitle">
             Sending to <strong>{selectedUsers.length}</strong> user{selectedUsers.length !== 1 ? 's' : ''}
           </p>
 
           <textarea
             ref={textareaRef}
             value={message}
             onChange={(e) => setMessage(e.target.value)}
             placeholder="Type your message here..."
             className="send-message-textarea"
             rows={4}
           />
         </div>
 
         <div className="send-message-footer">
           <button className="send-message-btn cancel" onClick={handleClose}>
             Cancel
           </button>
           <button 
             className="send-message-btn confirm" 
             onClick={handleSend}
             disabled={!message.trim()}
           >
             Send Message
           </button>
         </div>
       </div>
     </div>
   );
 };
 
 export default SendMessageModal;
 
 const CloseIcon = () => (
   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
     <path d="M18 6 6 18" />
     <path d="m6 6 12 12" />
   </svg>
 );